<div class="apm-card shadow d-flex" *ngIf="news()" (click)="onCardClick()">
  <div class="apm-card-image col-4 me-3">
    <apm-news-img [fileName]="news().coverFilename" [imgAlt]="news().title"></apm-news-img>
  </div>
  <div class="apm-card-content d-flex flex-column col-7">
    <div class="created-at italic mb-3">{{ news().created.at | momentDate }}</div>
    <hr class="gray-divider-1" />
    <div class="text-md bold col-8 mt-3">{{ news().title }}</div>
  </div>
</div>
